module.exports = __webpack_public_path__ + "static/kanbanery-05b729aa4c7e53c43508b7e2e09a646a.png";